import axios from "axios";
import config from "@assets/config.json"; // api 请求json

const state = {};
const mutations = {};
const getters = {};
const actions = {
  addExhibitionBaseNeedSettle ({ rootState }, opt) { // 新增活动
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/ExhibitionBaseNeedSettle`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  getExhibitionBaseNeedSettleById ({ rootState }, id) {
    // 获取活动详情
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/ExhibitionBaseNeedSettle/getAllByExId?Id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  getExhibitionBaseNeedSettleByType ({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/ExhibitionBaseNeedSettle/getAllByTypeName?exhibitionId=${opt.exhibitionId}&getByTypName=${opt.type}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  editExhibitionBaseNeedSettleInfo ({ rootState }, opt) {
    // 修改活动信息
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/ExhibitionBaseNeedSettle`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    });
  },
  delExhibitionBaseNeedSettle ({ rootState }, id) { // 删除下载
    return new Promise((resolve, reject) => {
      axios.delete(`${config.api.reqApi}/api/ExhibitionBaseNeedSettle?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },



  addCompanyBaseNeedFile ({ rootState }, opt) { // 新增活动
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/CompanyBaseNeedFile`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  getCompanyBaseNeedFileById ({ rootState }, id) {
    // 获取活动详情
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/CompanyBaseNeedFile/getAllByExId?Id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  getCompanyBaseNeedPage ({ rootState }, opt) {
    // 获取活动详情
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/CompanyBaseNeedFile/getByPage`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  editCompanyBaseNeedFileInfo ({ rootState }, opt) {
    // 修改活动信息
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/CompanyBaseNeedFile`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    });
  },
  delCompanyBaseNeedFile ({ rootState }, id) { // 删除下载
    return new Promise((resolve, reject) => {
      axios.delete(`${config.api.reqApi}/api/CompanyBaseNeedFile?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },


  getCompanyBaseNeedFileGetByCompId ({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/CompanyBaseNeedFile/GetByCompId?exhibitionId=${opt.exhibitionId}&compId=${opt.compId}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  addCompanyBaseNeedFile ({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/CompanyBaseNeedFile`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  editCompanyBaseNeedFile ({ rootState }, opt) {
    // 修改活动信息
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/CompanyBaseNeedFile`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    });
  }, 
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
